// File: AppRouter.js
import React, { useEffect, useState } from 'react';
import { Routes, Route, useLocation } from 'react-router-dom';
import { publicRoutes, privateRoutes, adminRoutes } from '../../Routes';
import { useAuth } from '../../AuthContext';
import DefaultLayout from '../../layouts/DefaultLayout';
import AuthLayout from '../../layouts/AuthLayout';
import AdminLayout from '../../layouts/AdminLayout';
import UpgradeLayout from '../../layouts/UpgradeLayout';
import Loading from '../../components/Loading';
import PrivateRoute from '../../PrivateRoute';
import RedirectIfLoggedIn from '../../RedirectIfLoggedIn';
import PageNotFound from '../../pages/Public/PageNotFound';

const MainLayout = () => {
  const { user, loading, role, isVerified } = useAuth();
  const [isInitialLoading, setIsInitialLoading] = useState(true);
  const location = useLocation();

  useEffect(() => {
    const allRoutes = [...publicRoutes, ...privateRoutes, ...adminRoutes];
    const currentRoute = allRoutes.find((route) => route.path === location.pathname);

    if (currentRoute?.title) {
      document.title = currentRoute.title;
    } else {
      document.title = "Webdio";
    }
  }, [location]);

  useEffect(() => {
    if (isInitialLoading) {
      setTimeout(() => {
        setIsInitialLoading(false);
      }, 500);
    }
  }, []);

  if (loading || isInitialLoading) {
    return <Loading />;
  }

  let Layout;

  if (location.pathname.startsWith('/upgrade')) {
    Layout = UpgradeLayout;
  } else if (!user || !isVerified) {
    Layout = DefaultLayout;
  } else if (role === 'admin') {
    Layout = AdminLayout;
  } else {
    Layout = AuthLayout;
  }

  return (
    <Layout>
      <Routes>
        {publicRoutes.map((route, index) => {
          const Page = route.component;
          return (
            <Route
              key={index}
              path={route.path}
              element={
                <RedirectIfLoggedIn>
                  <Page />
                </RedirectIfLoggedIn>
              }
            />
          );
        })}

        {privateRoutes.map((route, index) => {
          const Page = route.component;
          return (
            <Route
              key={index}
              path={route.path}
              element={
                <PrivateRoute>
                  <Page />
                </PrivateRoute>
              }
            />
          );
        })}

        {role === 'admin' &&
          adminRoutes.map((route, index) => {
            const Page = route.component;
            return (
              <Route
                key={index}
                path={route.path}
                element={
                  <PrivateRoute>
                    <Page />
                  </PrivateRoute>
                }
              />
            );
          })}

        <Route path="*" element={<PageNotFound />} />
      </Routes>
    </Layout>
  );
};

export default MainLayout;
